import { Button } from "../components/Button";
import { Modal } from "../components/Modal";
import { Dropdown } from "../components/Dropdown";
import { Typography } from "../components/Typography";
import { siteTypeCodeData, useSiteTypes } from "../hooks/useSiteTypes";
import { useBookingReasons, BookingReason } from "../hooks/useBookingReasons";
import { useIsInternalUser } from "../hooks/useUserPermissions"
import { Model } from "../Model";
import { useState } from "react";
import { useNav } from "../hooks/useNav";
import { useNavigate } from "react-router-dom";

export interface props {
    mpan: string,
    serviceLine: string,
    closeModalFunction: any
}

export const SiteTypeUpdateModal = (props: props) => {
    const getSiteTypes = useSiteTypes();
    const bookingReasons = useBookingReasons(props.serviceLine);

    const isInternalUser = useIsInternalUser();

    const rootNodeAddress = `/bookJob/siteJobType/${props.mpan}/${props.serviceLine}`;
    const siteTypes: siteTypeCodeData[] = getSiteTypes(props.serviceLine as "HH" | "NHH" | "SUBMETER" | "DNO" | "BNO" | "MSS" | "MSA");
    const nav = useNavigate();
    const [errorMissingSiteType, setErrorMissingSiteType] = useState(false);
    const [errorMissingBookingReason, setErrorMissingBookingReason] = useState(false);

    const handleSiteTypeConfirmation = () => {
        const siteType = Model.GetModel().Get("viewModel.updatedSiteType");
        const bookingReason = Model.GetModel().Get("viewModel.bookingReason");

        const progressWithBooking = siteType != "" && siteType != undefined && (isInternalUser ? (bookingReason != "" && bookingReason != undefined) : true);

        if(progressWithBooking) {
            if(!isInternalUser) {
                const supplierReason = bookingReasons.bookingReasons?.find(reason => reason.bookingPurposeDescription == "Supplier Booking");
                Model.GetModel().Set("model.results.bookingReasonId", supplierReason?.bookingPurposeId);
            }
            useNav(rootNodeAddress, nav);
        }
        if(isInternalUser && (bookingReason == "" || bookingReason == undefined)) {
            setErrorMissingBookingReason(true);
        }

        if(siteType == "" || siteType == undefined) {
            setErrorMissingSiteType(true);
        }
    }

    const handleSiteTypeDropdownSelect = (index: number, siteTypeDescription: string) => {
        const getSelectedCode = (siteTypeDescription: string) => {
            let selectedCode = "";
            siteTypes.forEach((code) => {
                if(siteTypeDescription == code.siteTypeDescription) {
                    selectedCode = code.siteTypeCode;
                }
            })
            return selectedCode;
        }

        const selectedCode = getSelectedCode(siteTypeDescription);
        const isWCSiteType = selectedCode.indexOf("WC") != -1;

        Model.GetModel().Set("model.results.updatedSiteType", selectedCode);
        Model.GetModel().Set("viewModel.isWCJob", isWCSiteType);

        return { isValid: true, errorMessage: "" };
    }

    const handleBookingReasonDropdownSelect = (index: number, bookingReason: BookingReason) => {
        Model.GetModel().Set("model.results.bookingReasonId", bookingReason.bookingPurposeId);
        return { isValid: true, errorMessage: "" };
    }

    const getInitialSiteType = () => {
        const getSelectedDescription = (siteTypeCode: string) => {
            let selectedDescription = "";
            siteTypes.forEach((code) => {
                if(siteTypeCode == code.siteTypeCode) {
                    selectedDescription = code.siteTypeDescription;
                }
            })
            return selectedDescription;
        }
        const siteType = getSelectedDescription(Model.GetModel().Get("viewModel.fetchedData.siteData.siteType"));
        return siteType;
    }

    const modalTitle = "Pre Booking Confirmation";

    return (
        <Modal title={modalTitle} className="w-1/3">
            <Typography content={`Before proceeding with the booking please confirm the site type and reason for making this booking`} className="mb-3" />
            <span></span>
            <Dropdown title="Site Type" mandatory={true} placeholder="Please confirm the site type for this booking" elementsDataSource={""} initialValue={getInitialSiteType()} elementsForDisplay={siteTypes.map((siteType) => siteType.siteTypeDescription)} onSelect={handleSiteTypeDropdownSelect} modelPath={"viewModel.updatedSiteType"} />
            {errorMissingSiteType ? <Typography content="Please select a site type before proceeding" className="text-feedback-red" /> : <span></span>}

            {
                !isInternalUser ?
                    <span></span>
                    :
                    <div>
                        <Dropdown title="Reason for Booking" mandatory={true} placeholder="Please confirm the reason for making this booking" elementsDataSource={""} initialValue="" elementsForDisplay={bookingReasons.bookingReasons?.map(reason => reason.bookingPurposeDescription).filter((reason): reason is string => reason !== undefined)} onSelect={(index: number, value: string) => handleBookingReasonDropdownSelect(index, bookingReasons.bookingReasons[index] as BookingReason)} modelPath={"viewModel.bookingReason"} />
                        {errorMissingBookingReason ? <Typography content="Please select a booking reason before proceeding" className="text-feedback-red" /> : <span></span>}
                    </div>
            }
            <div className="float-right">
                <Button primary={false} text="Cancel" className="mr-4" disabled={false} onClick={() => { props.closeModalFunction(false) }} />
                <Button primary={false} text="Ok" disabled={false} onClick={handleSiteTypeConfirmation} />
            </div>


        </Modal>
    )
}
